import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { FC, useState } from 'react'
import { Dropdown, DropdownOption } from 'src/components/dropdown'
import { FlexColumn } from 'src/components/flex-containers'
import { Colors } from 'src/components/theme'
import { YearPicker } from 'src/components/year-picker'

const VALUE_OPTIONS: DropdownOption[] = [
  {
    id: 'all',
    label: 'All Activity',
  },
  {
    id: 's-e',
    label: 'Something Else',
  },
]

const Container = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
`

const ValueDropdown = styled(Dropdown)`
  width: 160px;
`

const YearPickerWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const BuyVsSellOvertimeFilters: FC = () => {
  const [value, setValue] = useState('all')
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())

  const onValueChange = (value: string | null) => {
    if (!value) {
      return
    }
    setValue(value)
  }

  const onStartDateChange = (value: Date | null) => {
    if (!value) {
      return
    }
    setStartDate(value)
  }

  const onEndDateChange = (value: Date | null) => {
    if (!value) {
      return
    }
    setEndDate(value)
  }

  return (
    <Container>
      <FlexColumn>
        <Typography variant="text1" color={Colors.grayBlue900}>
          Value:
        </Typography>
        <ValueDropdown value={value} options={VALUE_OPTIONS} onChange={onValueChange} />
      </FlexColumn>
      <div>
        <Typography variant="text1" color={Colors.grayBlue900}>
          Time Period:
        </Typography>
        <YearPickerWrapper>
          <YearPicker date={startDate} onDateChange={onStartDateChange} />
          -
          <YearPicker date={endDate} onDateChange={onEndDateChange} />
        </YearPickerWrapper>
      </div>
    </Container>
  )
}
